import { useState, useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Drawer } from '@mantine/core';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';

import messages from './messages';
import style from './returns-config-iframe-modal.module.less';

const DRAWER_CLASS_NAMES = {
  content: style['drawer-content'],
  header: style['drawer-header'],
  body: style['drawer-body'],
};

type IframeWithLoaderProps = {
  iframeUrl: string;
};

const IframeWithLoader = ({ iframeUrl }: IframeWithLoaderProps) => {
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState(true);
  const handleLoad = useCallback(() => setIsLoading(false), []);

  return (
    <div className={style['iframe-container']}>
      {isLoading && <LoadingIndicator className={style.loader} />}
      <iframe
        className={style.iframe}
        onLoad={handleLoad}
        sandbox='allow-same-origin allow-scripts allow-forms allow-popups'
        src={iframeUrl}
        title={intl.formatMessage(messages.returnsConfigurationTitle)}
      />
    </div>
  );
};

type ReturnsConfigIframeModalProps = {
  isOpen: boolean;
  onClose: () => void;
  iframeUrl: string;
};

export const ReturnsConfigIframeModal = ({ isOpen, onClose, iframeUrl }: ReturnsConfigIframeModalProps) => {
  return (
    <Drawer
      classNames={DRAWER_CLASS_NAMES}
      closeButtonProps={{ 'aria-label': 'Close' }}
      onClose={onClose}
      opened={isOpen}
      position='bottom'
      size='calc(100vh - 64px)'
      title={<FormattedMessage {...messages.returnsConfigurationTitle} />}
    >
      <IframeWithLoader key={iframeUrl} iframeUrl={iframeUrl} />
    </Drawer>
  );
};
